import { NavLink } from "react-router-dom";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import CoursePicker from "./CoursePicker";
import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";

const leftNavActiveStudent = [
	{ name: "Home", href: "/home", current: false },
	{ name: "Writing", href: "/writing", current: false },
	{ name: "Reviews", href: "/reviews", current: false },
	{ name: "Lessons", href: "/lessons", current: false },
	{ name: "Reports", href: "/reports", current: false },
];

const leftNavActiveTeacher = [
	{ name: "Home", href: "/home", current: false },
	{ name: "Writing", href: "/writing", current: false },
	{ name: "Reviews", href: "/reviews", current: false },
	{ name: "Lessons", href: "/lessons", current: false },
	{ name: "Course", href: "/course", current: false },
	{ name: "Reports", href: "/reports", current: false },
];

const leftNavInactive = [{ name: "Reports", href: "/reports", current: false }];

// rightNav is only used on the compact view
const rightNav = [{ name: "Courses", href: "/courses", current: true }];

interface Props {
	isCourseActive?: boolean;
	showLeftNav?: Boolean;
}

export default function CollapsibleNavbar(props: Props) {
	const { role } = useAppSelector((state) => state.user);

	const isWriter = role === UserRole.Writer;

	const leftNav = props.isCourseActive
		? isWriter
			? leftNavActiveStudent
			: leftNavActiveTeacher
		: leftNavInactive;

	return (
		<Disclosure as="nav">
			{({ open }) => (
				<>
					<div className="mx-auto max-w-screen-2xl">
						<div className="flex items-center py-1.5 h-14">
							<div className="flex items-center justify-between w-full">
								<div
									className={`${isWriter ? "sm:block" : "min-[910px]:block"} hidden`}>
									{props.showLeftNav && (
										<div className="flex space-x-4">
											{leftNav.map((item) => (
												<NavLink
													key={item.name}
													to={item.href}
													className={({ isActive }) => `${
														isActive
															? "text-white font-bold underline underline-offset-4 decoration-1"
															: "text-indigo-100"
													}
															font-medium rounded-md bg-white/0 px-3 py-2 hover:bg-white/10`}
													aria-current={
														item.current ? "page" : undefined
													}>
													{item.name}
												</NavLink>
											))}
										</div>
									)}
								</div>
								<div
									className={`${isWriter ? "sm:block" : "min-[910px]:block"} hidden`}>
									<div className="flex space-x-4">
										<NavLink
											key="CoursePicker"
											to="/courses"
											onClick={(e) => {
												e.preventDefault();
											}}>
											{({ isActive }) => <CoursePicker isActive={isActive} />}
										</NavLink>
									</div>
								</div>
							</div>

							<div
								className={`${isWriter ? "sm:hidden" : "min-[910px]:hidden"} -mr-2 flex"`}>
								{/* Mobile menu button */}
								<DisclosureButton className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-white">
									<span className="sr-only">Open main menu</span>
									{open ? (
										<XMarkIcon className="block h-6 w-6" aria-hidden="true" />
									) : (
										<Bars3Icon className="block h-6 w-6" aria-hidden="true" />
									)}
								</DisclosureButton>
							</div>
						</div>
					</div>

					<DisclosurePanel className={`${isWriter ? "sm:hidden" : "min-[910px]:hidden"}`}>
						<div className="space-y-1 px-2 pt-2 pb-3">
							{props.showLeftNav && (
								<>
									{leftNav.map((item) => (
										<NavLink
											key={item.name}
											to={item.href}
											className={({ isActive }) =>
												`${
													isActive
														? "bg-primary-800 text-white"
														: "text-gray-300 hover:bg-primary-600 hover:text-white"
												}
													block rounded-md px-3 py-2 text-base font-medium no-underline`
											}>
											{item.name}
										</NavLink>
									))}
									<hr className="" />
								</>
							)}
							{rightNav.map((item) => (
								<NavLink
									key={item.name}
									to={item.href}
									className={({ isActive }) =>
										`${
											isActive
												? "bg-primary-800 text-white"
												: "text-gray-300 hover:bg-primary-600 hover:text-white"
										}
													block rounded-md px-3 py-2 text-base font-medium no-underline`
									}>
									{item.name}
								</NavLink>
							))}
						</div>
					</DisclosurePanel>
				</>
			)}
		</Disclosure>
	);
}
